export default __webpack_public_path__ + "static/media/zuckerberg2.5d5fb72e.png";